import { authAxios as axios } from "shared-auth";
import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import { config } from "config";
import { socialMediaQueryKey } from "../../constants";

export function useDisconnectInstagramAccount({
  profileId,
  instagramAccountId,
  onSuccessCallback,
}: {
  instagramAccountId: number;
  profileId: string;
  onSuccessCallback?: () => void;
}) {
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError>({
    mutationFn: () =>
      axios.delete(
        `${config.profileApiUrl}/profiles/${profileId}/social/accounts/${instagramAccountId}`
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries(socialMediaQueryKey);
      onSuccessCallback?.();
    },
  });
}
